import React from "react";

const Dashboard = () => {
  return (
    <div className="border border-sky-500 p-2 lg:my-5 lg:mx-14 ">
      <h2 className="text-sky-500 font-semibold text-3xl text-center">
        Dashboard
      </h2>
    </div>
  );
};

export default Dashboard;
